export const ADD_DGI_TAXES = 'ADD_DGI_TAXES'
